// "Găsește-ți forma" homepage section. Two side-by-side columns:
//   - După formă  → body_type taxonomy (from AP_DATA.bodies, WP-sourced)
//   - După buget → price brackets (configurable via window.AP_DATA.budgets)
import { qs } from '../lib/dom.js';
import { AP_DATA } from '../data/listings.js';

// Tile images map. The form column reuses these by body slug; new bodies
// added in WP fall back to the generic SUV image.
const BODY_IMAGES = {
  sedan: 'img/types/middle-class.png',
  hatchback: 'img/types/middle-class.png',
  suv: 'img/types/suv.png',
  crossover: 'img/types/suv.png',
  coupe: 'img/types/sport.png',
  wagon: 'img/types/van.png',
  pickup: 'img/types/van.png',
  ev: 'img/types/sport.png',
  electric: 'img/types/sport.png',
};

function imageFor(slug) {
  return BODY_IMAGES[String(slug || '').toLowerCase()] || 'img/types/suv.png';
}

function catalogUrl() {
  return AP_DATA.catalog || '/cars/';
}

// Budget brackets - labels translated via the server when available.
const DEFAULT_BUDGETS = [
  { name: 'Budget', max: 12000 },
  { name: 'Clasa medie', min: 12000, max: 30000 },
  { name: 'Premium', min: 30000, max: 60000 },
  { name: 'Exclusive', min: 60000 },
];

function budgetTiles() {
  const cfg = AP_DATA.budgets && AP_DATA.budgets.length ? AP_DATA.budgets : DEFAULT_BUDGETS;
  return cfg.map((b, i) => {
    const params = new URLSearchParams();
    if (b.min != null) params.set('priceMin', b.min);
    if (b.max != null) params.set('priceMax', b.max);
    return {
      name: b.name,
      count: b.count != null ? b.count : null,
      image: b.image || `img/types/${['budget', 'middle-class', 'premium', 'exclusive'][i] || 'suv'}.png`,
      href: `${catalogUrl()}?${params.toString()}`,
    };
  });
}

function formTiles() {
  return (AP_DATA.bodies || []).filter((b) => b.key && b.key !== 'all').map((b) => {
    const params = new URLSearchParams();
    params.set('body', b.key);
    return {
      name: b.name,
      count: b.count,
      image: imageFor(b.key),
      href: `${catalogUrl()}?${params.toString()}`,
    };
  });
}

function tileHTML(c) {
  return `
    <a class="ap-body-tile" href="${c.href}">
      <span class="ap-body-tile__icon" aria-hidden="true">
        <img src="${c.image}" alt="" loading="lazy" decoding="async">
      </span>
      <span class="ap-body-tile__name">${c.name}</span>
      ${c.count != null ? `<span class="ap-body-tile__count">${c.count}</span>` : ''}
    </a>
  `;
}

export function initBodyTiles() {
  const root = qs('[data-component="body-tiles"]');
  if (!root) return;
  // Honor server-side rendering. Skip JS render when the PHP partial has
  // already painted the tiles (data-server-rendered="1" on the parent).
  if (root.dataset.serverRendered === '1') {
    delete root.dataset.serverRendered;
    return;
  }
  const budget = qs('[data-role="body-tiles-budget"]', root);
  const form = qs('[data-role="body-tiles-form"]', root);
  if (budget) budget.innerHTML = budgetTiles().map(tileHTML).join('');
  if (form) form.innerHTML = formTiles().map(tileHTML).join('');
}
